import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import UserMenu from '../components/userMenu'
import * as authService from '../services/authService'
import Toast from './sub_components/toast'
class PriceButtonConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profileData: {},
            configData: [{ "name": "", "value": "" }, { "name": "", "value": "" }, { "name": "", "value": "" }, { "name": "", "value": "" }, { "name": "", "value": "" }, { "name": "", "value": "" }],
            showToast: false,
            toastMsg: "",
            toastType: "",
        };
    }
    async componentDidMount() {
        this.getConfigButton()
    }
    async getConfigButton() {
        let configData = await authService.getConfigButton()
        localStorage.setItem("buttonsValues", JSON.stringify(configData))
        let obj = {}
        if (configData.length === 0) {
            for (let index = 0; index < 6; index++) {
                obj = { "name": "", "value": "" }
                if (index === 0) {
                    obj["name"] = "100"
                    obj["value"] = 100
                }
                else if (index === 1) {
                    obj["name"] = "500"
                    obj["value"] = 500
                }
                else if (index === 2) {
                    obj["name"] = "1000"
                    obj["value"] = 1000
                }
                else if (index === 3) {
                    obj["name"] = "5000"
                    obj["value"] = 5000
                }
                else if (index === 4) {
                    obj["name"] = "10000"
                    obj["value"] = 10000
                }
                else if (index === 5) {
                    obj["name"] = "50000"
                    obj["value"] = 50000
                }
                // else if (index === 6) {
                //     obj["name"] = "100000"
                //     obj["value"] = 100000
                // }
                configData.push(obj)
            }
        } else if (configData.length < 6) {
            for (let i = 0; i < (6 - configData.length); i++) {
                obj = { "name": "", "value": "" }
                configData.push(obj)
            }
        }
        this.setState({ configData: configData })
    }
    async onSubmit() {
        let body = this.state.configData
        for (let index = 0; index < body.length; index++) {
            if (body[index]["name"] === "" && body[index]["value"] === "") {
                if (index === 0) {
                    body[index]["name"] = "100"
                    body[index]["value"] = 100
                }
                else if (index === 1) {
                    body[index]["name"] = "500"
                    body[index]["value"] = 500
                }
                else if (index === 2) {
                    body[index]["name"] = "1000"
                    body[index]["value"] = 1000
                }
                else if (index === 3) {
                    body[index]["name"] = "5000"
                    body[index]["value"] = 5000
                }
                else if (index === 4) {
                    body[index]["name"] = "10000"
                    body[index]["value"] = 10000
                }
                else if (index === 5) {
                    body[index]["name"] = "50000"
                    body[index]["value"] = 50000
                }
                // else if (index === 6) {
                //     body[index]["name"] = "100000"
                //     body[index]["value"] = 100000
                // }
            }
            else if (body[index]["name"] === "") {
                body[index]["name"] = (body[index]["value"]).toString()
            }
            else if (body[index]["value"] === "") {
                body[index]["value"] = parseFloat(body[index]["name"])
            }

        }
        body = this.clean(body);
        await authService.postConfigButton(body).then((res) => {
            if (res.isSuccess) {
                this.props.notify("Set Button Value Added Successfully!", "success")
                this.getConfigButton()
            } else {
                this.props.notify(res.exception.message, "error")
            }
        })
    }
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    addConfig() {
        let configData = this.state.configData
        let obj = { "name": "", "value": "" }
        configData.push(obj)
        this.setState({ configData: configData })
    }
    onChange(e, config, i) {
        let configData = this.state.configData
        const name = e.target.name;
        const value = e.target.value;
        if (name === "name") {
            configData[i].name = value
        }
        else {
            if (value !== "") {
                configData[i].value = parseFloat(value)
            } else {
                configData[i].value = value
            }
        }
        this.setState({ configData: configData })
    }
    render() {
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className="full-wrap">
                    <UserMenu history={this.props.history} key="usermenu" />
                    <div className="col-center1 markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>Set Stake</p>
                            </div>
                            <div className="allreport col3">
                                <div className="dt-responsive table-responsive account-statment p-2">
                                    <table id="basic-btn" className="table table-bordered nowrap table-sm mb-1 addpadding">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>ID</th>
                                                <th>Button Name</th>
                                                <th>Button Value</th>
                                            </tr>
                                        </thead>
                                        <tbody id="tblAccountStatement">

                                            <tr style={{ display: "none" }}>
                                                <td colSpan="9" className="text-center"><h5 className="text-danger font-weight-bold m-0">No Bets</h5></td>
                                            </tr>
                                            {!!this.state.configData && this.state.configData.map((config, i) => {
                                                if (i >= 6) {
                                                    return false
                                                }
                                                return (<tr key={"tr_" + i}>
                                                    <td className="w-8">{i + 1}</td>
                                                    <td className="w-46"><input type="text" name="name" className="form-control" onChange={(e) => { this.onChange(e, config, i) }} value={config.name} /></td>
                                                    <td className="w-46"><input type="text" name="value" className="form-control" onChange={(e) => { this.onChange(e, config, i) }} value={config.value} /></td>
                                                </tr>)
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row text-left mx-0 px-1">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 my-3">
                                        <button className="place-bet-btn" onClick={() => { this.onSubmit() }}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!!this.state.showToast && <Toast key={"toast"} notification={this.state.toastMsg} type={this.state.toastType} />}
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(PriceButtonConfig);